export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8849.6c299c50.jpg";